var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Prop } from 'vue-property-decorator';
import MarkdownForTooltip from "../../MarkdownForTooltip";
let FieldLabel = class FieldLabel extends Vue {
  render() {
    var _this$schema;
    const h = arguments[0];
    if (!this.text) return;
    return h("label", {
      "attrs": {
        "for": this.htmlFor
      },
      "class": 'uc-propForm-label-title',
      "style": !this.compact && 'line-height:28px'
    }, [h("span", {
      "on": {
        "click": this.$listeners
      }
    }, [this.text]), (_this$schema = this.schema) !== null && _this$schema !== void 0 && _this$schema.description ? h("a-tooltip", [h(MarkdownForTooltip, {
      "slot": 'title',
      "attrs": {
        "source": this.schema.description
      }
    }), h("a-icon", {
      "attrs": {
        "type": 'info-circle'
      }
    })]) : null]);
  }
};
__decorate([Prop({
  type: String,
  required: false
})], FieldLabel.prototype, "htmlFor", void 0);
__decorate([Prop({
  type: String,
  required: false
})], FieldLabel.prototype, "text", void 0);
__decorate([Prop({
  type: Object
})], FieldLabel.prototype, "schema", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], FieldLabel.prototype, "compact", void 0);
FieldLabel = __decorate([Component({
  name: 'FieldLabel'
})], FieldLabel);
export default FieldLabel;
//# sourceMappingURL=FieldLabel.js.map
